module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[47]412.58343ba.woff2";